module.exports = __webpack_public_path__ + "img/download.7318b503.svg";